// extracted by mini-css-extract-plugin
module.exports = {"tree":"_1pW5x","iconShared":"_1ySJ5"};